import React from "react";

import {
  PrimaryButton,
  SecondaryButton,
} from "@graffer-inc/console-design-kit";

type Props = {
  onCreate: () => void;
  onCancel: () => void;
  isLoading: boolean;
};

export const ServiceAccountCreateButtons: React.FC<Props> = ({
  onCreate,
  onCancel,
  isLoading,
}) => {
  return (
    <nav className="level">
      <div className="level-left"></div>
      <div className="level-right">
        <p className="level-item">
          <SecondaryButton
            text="キャンセル"
            onClick={onCancel}
            disabled={isLoading}
          />
        </p>
        <p className="level-item">
          <PrimaryButton text="登録" onClick={onCreate} disabled={isLoading} />
        </p>
      </div>
    </nav>
  );
};
